module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_jp.e997312957e4b7316f3225dc0ccd9329.png";